module.exports = __webpack_public_path__ + "img/health-d.a8b65fae.png";